import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { HashLink } from "react-router-hash-link"
import { FaAngleDoubleDown } from "react-icons/all"

// components
import Banner from "../components/banner"
import Beats from "../components/home/beats"
import Releases from "../components/home/releases"
import About from "../components/home/about"
import Services from "../components/home/services"
import Footer from "../components/footer"

const Home = () => {
  useEffect(() => {
    document.title = "Home - Soz the govt Music Production"
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="home">
      <Banner bannerClass="home-banner">
        <div className="column column-left">
          <h1>
            <strong>MUSIC</strong>&nbsp;PRODUCTION
          </h1>
          <h3>We make beats, we sell hits</h3>
          <div className="btns">
            <Link to="/beats" className="btn btn-primary">
              Our Works
            </Link>
            <Link to="/contact-us" className="btn btn-secondary">
              Contact Us
            </Link>
          </div>
          <p className="float">Create Your Best Record With Us</p>
          <HashLink to="/#beats" className="hash-link">
            <FaAngleDoubleDown className="icon" />
          </HashLink>
        </div>
      </Banner>
      <main>
        <Beats />
        <Releases />
        <About />
        <Services />
      </main>
      <Footer />
    </div>
  )
}

export default Home
